module.exports = __webpack_public_path__ + "06_short_brown.12a706bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_short_brown.png
// module id = sdmw
// module chunks = 0